// extracted by mini-css-extract-plugin
module.exports = {"domLoad":"style_domLoad__1E8fU","fade-in":"style_fade-in__hnZF3"};